module.exports = __webpack_public_path__ + "4f5cbf6680a1d978e6428592bdd022aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_05.jpg
// module id = 625
// module chunks = 0